import { Beneficiary, PaymentServicesResponse } from '~/types';
import { cleanupFormValues } from '~/utils';
import axios, { ResponseType } from './axios';

export const getBeneficiaries = (params: any): ResponseType<Beneficiary[]> => {
  return axios.get(`/beneficiaries`, { params });
};

export const createBeneficiary = (body: Beneficiary): ResponseType<Beneficiary> => {
  return axios.post('/beneficiaries', body);
};

export interface TransferTypesParams {
  group?: string;
  name?: string;
  region?: string;
  paymentType?: string;
  next?: string;
  limit?: string;
}

export const getTransferTypes = (
  params?: TransferTypesParams
): ResponseType<PaymentServicesResponse> => {
  return axios.get('/payments/services?group=PAYOUT', {
    params: cleanupFormValues({ limit: 50, ...params }),
  });
};

export const deleteBeneficiary = (id: string): ResponseType<void> => {
  return axios.delete(`/beneficiaries/${id}`);
};

export const updateBeneficiary = (body: Beneficiary): ResponseType<Beneficiary> => {
  return axios.put(`/beneficiaries/${body.id}`, body);
};
